import { render } from "./ModalDeleteInvoice.vue?vue&type=template&id=4ce2361f"
import script from "./ModalDeleteInvoice.vue?vue&type=script&lang=js"
export * from "./ModalDeleteInvoice.vue?vue&type=script&lang=js"

import exportComponent from "/var/srv/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__